import * as React from 'react';
import { ApolloQueryResult } from '@apollo/client';

import type {
  GetAnnouncementStreamItems,
  GetAnnouncementStreamItemsVariables,
} from 'chat/components/AnnouncementStream/queries/__generated__/GetAnnouncementStreamItems';

type Refetch = (
  variables?: GetAnnouncementStreamItemsVariables
) => Promise<ApolloQueryResult<GetAnnouncementStreamItems>>;
type RefetchCallback = () => Refetch;
export interface ChatContextState {
  streamItemsRefetch?: Refetch;
  setStreamItemsRefetch?: (refetchCallback: RefetchCallback) => void;
  shouldRefetchStreamSections: boolean;
  setShouldRefetchStreamSections: (state: boolean) => void;
}

const initialState: ChatContextState = {
  shouldRefetchStreamSections: false,
  setShouldRefetchStreamSections: () => {},
};

export const ChatContext = React.createContext<ChatContextState>(initialState);

type DistanceLearningContextProviderProps = {
  children: React.ReactNode;
};

export const ChatContextProvider = ({ children }: DistanceLearningContextProviderProps) => {
  const [streamItemsRefetch, setStreamItemsRefetch] = React.useState<Refetch | undefined>();
  const [shouldRefetchStreamSections, setShouldRefetchStreamSections] = React.useState(
    initialState.shouldRefetchStreamSections
  );

  return (
    <ChatContext.Provider
      value={{
        streamItemsRefetch: streamItemsRefetch,
        setStreamItemsRefetch: (refetchCallback: RefetchCallback) => {
          setStreamItemsRefetch(refetchCallback);
        },
        shouldRefetchStreamSections: shouldRefetchStreamSections,
        setShouldRefetchStreamSections: (state) => {
          setShouldRefetchStreamSections(state);
        },
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
